module.exports = __webpack_public_path__ + "img/wedding_thumbnail-1.9e5fa0ee.jpg";